import React, { Component } from 'react'
import LoadingWindow from '../../components/LoadingWindow';
import TableListofUnsoldProducts from '../../components/TableListofUnsoldProducts/TableListofUnsoldProducts';
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithDataDashboard, getInformationWithDataGlobalSalesDashboard } from '../../services/CABE'
import { confirmCloseAlert } from '../../functions/alerts';
import { MonthInLetters, filterAndSortData } from '../../functions/generalFunctions';
import TableInventoryStatus from '../../components/TableInventoryStatus/TableInventoryStatus'
import { getPurchaseDetail } from './Functions';
import TableofPurchaseVendor from '../../components/TableofPurchaseVendor/TableofPurchaseVendor';
import { PurchaseByVendors } from './Class';
import TableInventoryRotation1 from '../../components/TableInvetoryRotation1/TableInventoryRotation1'
import TableInventoryRotation2 from '../../components/TableInventoryRotation2/TableInventoryRotation2'
import { Menu } from '../../components/Menu/Menu';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import '../../css/dashboard.css';
export default class Purcharsing extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        Data: [],
        Shortage: [],
        Rotation: [],
        RotationProdLine: [],
        PurchaseByVendor: new PurchaseByVendors(),
        Date: new Date(),
        Date2: new Date(),
        Date3: new Date(),
        pageNumers: [],
    }
    componentDidMount() {
        this.ItemsGetLastSaleList();
    }

    async ItemsGetLastSaleList() {
        this.ModalLoading.current.showState(true);

        const data = {
            IdCompany: 3,
            Start: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substring(0, 10),
            End: new Date().toISOString().substring(0, 10),
        }

        // Run all requests in parallel — a 504 on one endpoint won't block the others
        const [result, result2, result3, result4, PurchaseByVendor] = await Promise.allSettled([
            getInformationWithDataDashboard('/Items/Get/LastSaleListV2', { idCompany: 3 }),
            getInformationWithDataGlobalSalesDashboard('/v2/invoice/Shortage/Dashboard', { idCompany: 3 }),
            getInformationWithDataGlobalSalesDashboard('/Invoice/InvRotation', data),
            getInformationWithDataGlobalSalesDashboard('/Invoice/InvRotationByProdLine', data),
            getPurchaseDetail(null),
        ]);

        if (result.status === 'fulfilled' && result.value && result.value.status && result.value.status.code === 1)
            this.setState({ Data: result.value.result });

        if (result2.status === 'fulfilled' && result2.value && result2.value.status && result2.value.status.code === 1)
            this.setState({ Shortage: result2.value.data });

        if (result3.status === 'fulfilled' && result3.value && result3.value.status && result3.value.status.code === 1)
            this.setState({ Rotation: result3.value.data });

        if (result4.status === 'fulfilled' && result4.value && result4.value.status && result4.value.status.code === 1)
            this.setState({ RotationProdLine: result4.value.data });

        if (PurchaseByVendor.status === 'fulfilled')
            this.setState({ PurchaseByVendor: PurchaseByVendor.value });

        this.ModalLoading.current.showState(false);
        this.pagination()
    }
    async changeAllMonthData(DateC) {
        this.ModalLoading.current.showState(true);
        const data = await getPurchaseDetail(new Date(DateC))

        await this.setState({ PurchaseByVendor: data, Date: new Date(DateC) })
        this.ModalLoading.current.showState(false);
    }

    async changeMonth(data, date) {
        this.ModalLoading.current.showState(true);
        await this.setState({ Date2: new Date(date) })

        if (new Date().toISOString().substring(0, 10) === this.state.Date2.toISOString().substring(0, 10)) {
            data = {
                IdCompany: 3,
                Start: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substring(0, 10),
                End: new Date().toISOString().substring(0, 10),
            }
        }
        const result1 = await getInformationWithDataGlobalSalesDashboard('/Invoice/InvRotation', data);
        const result2 = await getInformationWithDataGlobalSalesDashboard('/Invoice/InvRotationByProdLine', data);
        this.setState({ Rotation: result1.data, RotationProdLine: result2.data })
        this.ModalLoading.current.showState(false);
    }

    pagination() {

        const temp = []
        for (let i = 1; i <= Math.ceil(this.state.Rotation.length / 70); i++) {
            temp.push(i)
        }
        //console.log("aber el temp",temp)
        this.setState({ pageNumers: temp })
    }

    render() {
        return (
            <div className="dash-page container-fluid pb-5" style={{ paddingTop: '70px', minHeight: '100vh', background: '#F8FAFC' }}>
                <LoadingWindow ref={this.ModalLoading} />
                {this.props.showMenu && <Menu />}
                <button hidden id='actionatorPurchasing' onClick={() => this.state.Shortage.length !== 0 ? null : this.ItemsGetLastSaleList()}>button...</button>

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem', display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiOutlineShoppingCart style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Purchasing Dashboard</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Inventory status, purchase orders by vendor and rotation metrics</p>
                    </div>
                </div>

                {/* Row 1: Unsold Products + Purchase by Vendor */}
                <div className="row g-3 mb-3">
                    <div className={'col-sm-12 col-md-6' + (getValueCookie('CompanyId') === '6' ? ' d-none' : '')}>
                        <TableListofUnsoldProducts data1={this.state.Data} data={filterAndSortData(this.state.Data, 30)} Title={"List of Unsold Products"} />
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <TableofPurchaseVendor Father={this} Date={this.state.Date} Month={MonthInLetters(this.state.Date.getMonth() + 1) + " " + this.state.Date.getFullYear()} data={this.state.PurchaseByVendor} Title={"Purchase By Vendor"} />
                    </div>
                </div>

                {/* Row 2: Inventory Status */}
                <div hidden={getValueCookie('CompanyId') === '6'} className="mb-3">
                    <TableInventoryStatus data={this.state.Shortage} Title={"Inventory Status"} />
                </div>

                {/* Row 3: Inventory Rotation */}
                <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                        <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Inventory Rotation</span>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-sm-12 col-md-6">
                                <TableInventoryRotation1 Father={this} Date={this.state.Date2} Month={MonthInLetters(this.state.Date2.getMonth() + 1) + " " + this.state.Date2.getFullYear()} data={this.state.Rotation} pageNumers={this.state.pageNumers} Title={"Table 1"} />
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <TableInventoryRotation2 Father={this} Date={this.state.Date2} Month={MonthInLetters(this.state.Date2.getMonth() + 1) + " " + this.state.Date.getFullYear()} data={this.state.RotationProdLine} Title={"Table 2"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}